import { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import useGetIsMounted from './useGetIsMounted';
/**
 * Hook to allow a value to be debounced. Uses the lodash debounce function.
 * @param value The 'raw', un-debounced value
 * @param wait Time in milliseconds to wait
 * @param options Debouncing options - see the lodash debounce docs for details
 * @returns The debounced value
 */
export default function useDebouncedValue(value, wait, options) {
  const isMounted = useGetIsMounted();
  const [debouncedValue, setDebouncedValue] = useState(value);
  const setDebouncedState = useMemo(() => {
    return debounce(value => {
      isMounted() && setDebouncedValue(value);
    }, wait, options);
  }, [isMounted, options, wait]);
  useEffect(() => {
    setDebouncedState(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return debouncedValue;
}